export default {
  getContract: state => state.contract
}
